import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function ShippingPolicy() {
  const s = useSiteSettings();
  const name = s.business_name || "Gil Maakaroun";
  const email = s.contact_email || "";
  const address = s.business_address || "United States";
  return (
    <LegalLayout
      title="Shipping Policy"
      seoTitle="Shipping Policy"
      seoDescription={`How ${name} ships albums, packs, boxes, and missing stickers nationwide.`}
      intro="How we ship albums, packs, boxes, Gold Crumples, accessories, and missing stickers to collectors across the United States."
      effectiveDate="February 2026"
      testid="shipping-policy-page"
    >
      <h2>Where we ship</h2>
      <p>
        We ship <strong>nationwide within the United States</strong>, including
        all 50 states and Washington, D.C. International shipping is not
        currently offered.
      </p>

      <h2>Local options</h2>
      <ul>
        <li><strong>Local pickup</strong> by appointment. Location details for pickup are shared on your order confirmation ({address}).</li>
        <li><strong>Event pickup</strong> at any upcoming trading event — free, and a nice excuse to swing by.</li>
      </ul>

      <h2>Shopify storefront orders</h2>
      <ul>
        <li>Standard shipping is calculated at checkout in the Shopify storefront based on weight and destination.</li>
        <li>Typical processing time: <strong>1–3 business days</strong>. Typical transit time: <strong>2–7 business days</strong> depending on state.</li>
        <li>You will receive an email with tracking information as soon as the label is created.</li>
      </ul>

      <h2>Missing sticker requests</h2>
      <ul>
        <li>Missing-sticker orders are prepared manually and shipped in protective packaging.</li>
        <li>Small orders (a handful of stickers) usually ship in a rigid mailer within{" "}
          <strong>3–5 business days</strong> of payment.</li>
        <li>Large orders (dozens of stickers) may take{" "}
          <strong>5–10 business days</strong> to prepare and check.</li>
      </ul>

      <h2>Carriers</h2>
      <p>
        We use standard trackable carriers (USPS and UPS) depending on the size
        and value of the shipment. Signature confirmation is available on
        request for high-value orders.
      </p>

      <h2>Lost, delayed, or damaged shipments</h2>
      <ul>
        <li>If your tracking has not updated for <strong>7 consecutive business days</strong>, contact us and we&apos;ll open an inquiry with the carrier.</li>
        <li>If a package arrives damaged, take photos before opening further and email them within 48 hours of delivery.</li>
        <li>We will re-ship or refund the damaged items where the carrier confirms responsibility.</li>
      </ul>

      <h2>Costs</h2>
      <p>
        Shipping cost is calculated at checkout in the Shopify storefront or
        stated on the quote for missing-sticker orders. There are no hidden
        handling fees.
      </p>

      <h2>Contact</h2>
      <p>
        Shipping questions? {email ? (
          <>Reach us at <a href={`mailto:${email}`}>{email}</a> or via the <a href="/contact">Contact page</a>.</>
        ) : (
          <>Reach us via the <a href="/contact">Contact page</a>.</>
        )}
      </p>
    </LegalLayout>
  );
}
